import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Customer";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetSaleStatsOfCustomerByDateRange = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatsOfCustomerByDateRange`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const UpdateNewCustomerBonusLimit = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateNewCustomerBonusLimit`, options);

export const UpdateNewCustomerBonusAmount = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateNewCustomerBonusAmount`, options);

export const GetCustomerBonusSettings = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCustomerBonusSettings`, options);

export const GetCustomerPayments = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCustomerPayments`, options);

export const UpdateCustomerPaymentDate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CustomerPayments/:id/Date`, options);

export const ImportExcel = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ImportExcel`, options);

export const GetImportExcel = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetImportExcel`, options);

export const DeleteImportExcel = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ImportExcel/:customerExcelImportId`, options);

export const UpdateCustomerParasutInfo = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateCustomerParasutInfo/:id`, options);

export const DuplicateCheck = (options) =>
  GENERATE_URL(`${PREFIX_URL}/DuplicateCheck`, options);

export const Merge = (options) => GENERATE_URL(`${PREFIX_URL}/Merge`, options);

export const GetMerge = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Merge/:operationId`, options);

export const ResolveMissingLocations = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ResolveMissingLocations`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  GetSaleStatsOfCustomerByDateRange,
  UpdateNewCustomerBonusLimit,
  UpdateNewCustomerBonusAmount,
  GetCustomerBonusSettings,
  GetCustomerPayments,
  UpdateCustomerPaymentDate,
  ImportExcel,
  GetImportExcel,
  DeleteImportExcel,
  UpdateCustomerParasutInfo,
  DuplicateCheck,
  Merge,
  GetMerge,
  ResolveMissingLocations,
};
